'use strict';

import FormData from 'form-data';
import qs from 'querystring';
import fetch from 'node-fetch';

import { BaseService } from '@narrate/base-sdk';

export default class PhotoService extends BaseService {
  constructor() {
    super({ configPath: 'services.photo' });
  }

  async fetchPresets() {
    const { resources: { info: url }} = await this.config();

    const response = await this.request({
      url,
      method: 'GET',
      headers: { 'content-type': 'application/json' }
    });

    return response;
  }

  async fetchInfo(props) {
    const { resources: { info: url }} = await this.config();

    const response = await this.request({
      url: `${url}?${qs.stringify(props)}`,
      method: 'GET',
      headers: { 'content-type': 'application/json' }
    });

    return response.renditions;
  }

  async upload(image, assetType = 'profile') {
    const config = await this.config();
    const { appKey, resources: { upload: url }} = config;

    const fd = this.createFormData(image, { appKey, assetType });
    let response, data;

    try {
      // TODO: figure out how to use the fetchAdaptor for this...
      response = await fetch(url, { method: 'POST', body: fd });
      data = response.json ? await response.json() : {};

      if (response.status < 200 || response.status >= 400) {
        const message = data.message;
        throw {
          response,
          status: response.status,
          statusText: response.statusText,
          message,
          data,
        };
      }
    } catch (e) {
      console.log('Upload error: ', e);
    }

    console.log('Upload response: ', response);
    console.log('Upload response data: ', data);

    return data;
  }

  createFormData(image, options = {}) {
    const fd = new FormData();
    fd.append('image', image);

    Object.keys(options).forEach(key => {
      fd.append(key, options[key]);
    });

    return fd;
  }
}
